(function () {
  'use strict';

  var SWIPER_CONFIG = {
    loop: false,
    slidesPerView: 1.15,
    spaceBetween: 16,
    speed: 500,
    grabCursor: true,
    watchOverflow: true,
    breakpoints: {
      750: {
        slidesPerView: 2.2,
        spaceBetween: 20
      },
      990: {
        slidesPerView: 2.8,
        spaceBetween: 24
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 24
      }
    }
  };

  function destroySwiper(container) {
    if (container && container.swiper) {
      container.swiper.destroy(true, true);
    }
  }

  function initCarouselSwiper(section, swiperSelector, configOverrides) {
    var container = section.querySelector(swiperSelector);
    if (!container || typeof Swiper === 'undefined') return null;

    destroySwiper(container);

    var slideCount = container.querySelectorAll('.swiper-slide').length;
    var showNav = slideCount > 1;
    var navRoot = section.querySelector('.kb-fc-nav, .kb-mc-nav') || section;
    var baseConfig = configOverrides
      ? Object.assign({}, SWIPER_CONFIG, configOverrides)
      : SWIPER_CONFIG;
    var config = Object.assign({}, baseConfig, {
      navigation: showNav
        ? {
            nextEl: navRoot.querySelector('.swiper-button-next'),
            prevEl: navRoot.querySelector('.swiper-button-prev')
          }
        : false
    });

    var swiper = new Swiper(container, config);
    container.classList.add('is-ready');
    return swiper;
  }

  function getCarouselSwiperConfig(section) {
    var mobile = parseFloat(section.dataset.slidesMobile);
    var tablet = parseFloat(section.dataset.slidesTablet);
    var large = parseFloat(section.dataset.slidesLarge);
    var desktop = parseFloat(section.dataset.slidesDesktop);

    if (!mobile && !tablet && !large && !desktop) return null;

    return {
      slidesPerView: mobile || SWIPER_CONFIG.slidesPerView,
      breakpoints: {
        750: {
          slidesPerView: tablet || SWIPER_CONFIG.breakpoints[750].slidesPerView,
          spaceBetween: 20
        },
        990: {
          slidesPerView: large || tablet || SWIPER_CONFIG.breakpoints[990].slidesPerView,
          spaceBetween: 24
        },
        1200: {
          slidesPerView: desktop || SWIPER_CONFIG.breakpoints[1200].slidesPerView,
          spaceBetween: 24
        }
      }
    };
  }

  /* ── Features Carousel (modal + swiper) ── */

  function pauseModalMedia(modal) {
    if (!modal) return;
    modal.querySelectorAll('video').forEach(function (video) {
      video.pause();
      video.currentTime = 0;
    });
    modal.querySelectorAll('iframe').forEach(function (iframe) {
      iframe.removeAttribute('src');
    });
  }

  function playModalMedia(modal) {
    if (!modal) return;
    modal.querySelectorAll('video').forEach(function (video) {
      if (video.readyState === 0) {
        video.load();
      }
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          video.muted = true;
          var mutedPlayPromise = video.play();
          if (mutedPlayPromise && typeof mutedPlayPromise.catch === 'function') {
            mutedPlayPromise.catch(function () {});
          }
        });
      }
    });
    modal.querySelectorAll('iframe[data-src]').forEach(function (iframe) {
      var src = iframe.dataset.src;
      if (src.indexOf('autoplay=1') === -1) {
        src += (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
      }
      iframe.src = src;
    });
  }

  function openModal(modal) {
    if (!modal) return;
    document.querySelectorAll('.kb-fc-modal.is-active').forEach(function (activeModal) {
      if (activeModal !== modal) {
        closeModal(activeModal);
      }
    });
    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('kb-fc-modal-open');
    playModalMedia(modal);
  }

  function closeModal(modal) {
    if (!modal) return;
    pauseModalMedia(modal);
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.kb-fc-modal.is-active')) {
      document.body.classList.remove('kb-fc-modal-open');
    }
  }

  function initFeaturesModals(section) {
    section.querySelectorAll('[data-kb-fc-open]').forEach(function (trigger) {
      if (trigger.dataset.kbFcBound) return;
      trigger.dataset.kbFcBound = 'true';

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var modalId = trigger.getAttribute('data-kb-fc-open');
        if (!modalId) return;
        var modal = Array.prototype.find.call(
          section.querySelectorAll('.kb-fc-modal'),
          function (candidate) {
            return candidate.id === modalId;
          }
        );
        if (!modal) return;
        openModal(modal);
      });
    });

    section.querySelectorAll('.kb-fc-modal').forEach(function (modal) {
      if (modal.dataset.kbFcBound) return;
      modal.dataset.kbFcBound = 'true';

      var overlay = modal.querySelector('.kb-fc-modal__overlay');
      var closeBtn = modal.querySelector('.kb-fc-modal__close');

      if (overlay) {
        overlay.addEventListener('click', function () {
          closeModal(modal);
        });
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          closeModal(modal);
        });
      }
    });
  }

  function initFeaturesCarousel(section) {
    if (!section || !section.classList.contains('kb-features-carousel')) return;
    initFeaturesModals(section);
    initCarouselSwiper(section, '.kb-fc-swiper', getCarouselSwiperConfig(section));
  }

  /* ── Media Carousel (swiper only) ── */

  function pauseSlideVideos(slide) {
    if (!slide) return;
    slide.querySelectorAll('video').forEach(function (video) {
      video.pause();
    });
  }

  function playSlideVideos(slide) {
    if (!slide) return;
    slide.querySelectorAll('video').forEach(function (video) {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    });
  }

  function initMediaCarouselVideos(swiper) {
    if (!swiper || !swiper.el) return;

    var section = swiper.el.closest('.kb-media-carousel');
    if (!section) return;

    swiper.on('slideChange', function () {
      section.querySelectorAll('.swiper-slide').forEach(pauseSlideVideos);
      playSlideVideos(swiper.slides[swiper.activeIndex]);
    });

    playSlideVideos(swiper.slides[swiper.activeIndex]);
  }

  function initMediaCarousel(section) {
    if (!section || !section.classList.contains('kb-media-carousel')) return;
    var swiper = initCarouselSwiper(section, '.kb-mc-swiper', getCarouselSwiperConfig(section));
    initMediaCarouselVideos(swiper);
  }

  /* ── Product Sticky Nav ── */

  var navInstances = [];

  function getHeaderHeight() {
    var header =
      document.querySelector('.site-header--stuck') ||
      document.querySelector('.site-header') ||
      document.querySelector('#StickyHeaderWrap');

    if (header) {
      return header.offsetHeight || 0;
    }

    return 77;
  }

  function ProductStickyNav(anchor) {
    this.anchor = anchor;
    this.wrapper = anchor.querySelector('.kb-th_wrapper');
    this.placeholder = anchor.querySelector('.kb-th_placeholder');
    this.navItems = anchor.querySelectorAll('.kb-th_nav ul li');
    this.navLinks = anchor.querySelectorAll('.kb-th_nav ul li a');
    this.ticking = false;
    this.stuck = false;
    this.wrapperTop = 0;

    if (!this.wrapper) return;

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.init();
  }

  ProductStickyNav.prototype.init = function () {
    this.updateMetrics();
    this.bindNavClicks();
    this.initScrollSpy();
    this.checkSticky();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
    window.addEventListener('orientationchange', this.onResize);
    window.addEventListener('load', this.onResize);
  };

  ProductStickyNav.prototype.destroy = function () {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('orientationchange', this.onResize);
    window.removeEventListener('load', this.onResize);

    if (this.observer) {
      this.observer.disconnect();
    }

    this.setStuck(false);
  };

  ProductStickyNav.prototype.onScroll = function () {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(
      function () {
        this.ticking = false;
        this.checkSticky();
      }.bind(this)
    );
  };

  ProductStickyNav.prototype.onResize = function () {
    this.updateMetrics();
    this.checkSticky();
  };

  ProductStickyNav.prototype.updateMetrics = function () {
    var headerHeight = getHeaderHeight();
    document.documentElement.style.setProperty('--kb-header-height', headerHeight + 'px');

    if (this.stuck) {
      this.setStuck(false);
    }

    var rect = this.wrapper.getBoundingClientRect();
    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    this.wrapperTop = rect.top + scrollY;
    this.wrapperHeight = this.wrapper.offsetHeight;
  };

  ProductStickyNav.prototype.checkSticky = function () {
    var headerHeight = getHeaderHeight();
    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var triggerY = this.wrapperTop - headerHeight;

    if (scrollY >= triggerY) {
      this.setStuck(true, headerHeight);
    } else {
      this.setStuck(false);
    }
  };

  ProductStickyNav.prototype.setStuck = function (isStuck, headerHeight) {
    if (isStuck) {
      var height = this.wrapper.offsetHeight;
      document.documentElement.style.setProperty('--kb-nav-height', height + 'px');
      this.wrapper.style.top = headerHeight + 'px';

      if (this.placeholder) {
        this.placeholder.style.height = height + 'px';
      }

      if (!this.stuck) {
        this.anchor.classList.add('is-stuck');
        this.wrapper.classList.add('is-stuck');
      }

      this.stuck = true;
      return;
    }

    if (!this.stuck) return;

    this.stuck = false;
    this.wrapper.style.top = '';
    this.anchor.classList.remove('is-stuck');
    this.wrapper.classList.remove('is-stuck');

    if (this.placeholder) {
      this.placeholder.style.height = '';
    }
  };

  ProductStickyNav.prototype.bindNavClicks = function () {
    var self = this;

    this.navLinks.forEach(function (link) {
      if (link.dataset.kbNavBound) return;
      link.dataset.kbNavBound = 'true';

      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');

        if (!href || href.charAt(0) !== '#') return;

        e.preventDefault();

        var li = link.closest('li');
        if (li) {
          self.navItems.forEach(function (item) {
            item.classList.remove('active');
          });
          li.classList.add('active');
        }

        self.scrollToTarget(href);
      });
    });
  };

  ProductStickyNav.prototype.scrollToTarget = function (selector) {
    var target = document.querySelector(selector);
    if (!target) return;

    var headerHeight = getHeaderHeight();
    var navHeight = this.wrapper.offsetHeight;
    var offset = headerHeight + navHeight + 16;
    var top =
      target.getBoundingClientRect().top +
      (window.pageYOffset || document.documentElement.scrollTop || 0) -
      offset;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth'
    });
  };

  ProductStickyNav.prototype.initScrollSpy = function () {
    var self = this;
    var sections = [];

    this.navLinks.forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;

      var el = document.querySelector(href);
      if (el) {
        sections.push({ element: el, link: link });
      }
    });

    if (!sections.length) return;

    this.observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var match = sections.find(function (section) {
            return section.element === entry.target;
          });

          if (!match) return;

          self.navItems.forEach(function (item) {
            item.classList.remove('active');
          });

          var li = match.link.closest('li');
          if (li) li.classList.add('active');
        });
      },
      {
        root: null,
        rootMargin: '-20% 0px -65% 0px',
        threshold: 0
      }
    );

    sections.forEach(function (section) {
      self.observer.observe(section.element);
    });
  };

  function initProductNav(anchor) {
    if (!anchor || anchor.dataset.kbNavInit) return;
    anchor.dataset.kbNavInit = 'true';
    navInstances.push(new ProductStickyNav(anchor));
  }

  function destroyProductNav(container) {
    var anchor = container.querySelector('[data-kb-product-nav]');
    if (!anchor) return;

    var index = navInstances.findIndex(function (instance) {
      return instance.anchor === anchor;
    });

    if (index !== -1) {
      navInstances[index].destroy();
      navInstances.splice(index, 1);
    }

    delete anchor.dataset.kbNavInit;
  }

  /* ── Init ── */

  function initAll() {
    document.querySelectorAll('.kb-features-carousel').forEach(initFeaturesCarousel);
    document.querySelectorAll('.kb-media-carousel').forEach(initMediaCarousel);
    document.querySelectorAll('[data-kb-product-nav]').forEach(initProductNav);
  }

  // Prevent duplicate global listeners when multiple sections load this script
  if (window.__kbProductInitialized) {
    initAll();
    return;
  }
  window.__kbProductInitialized = true;

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.kb-fc-modal.is-active').forEach(function (modal) {
      closeModal(modal);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var featuresSection = e.target.querySelector('.kb-features-carousel');
    var mediaSection = e.target.querySelector('.kb-media-carousel');
    initFeaturesCarousel(featuresSection);
    initMediaCarousel(mediaSection);
    initProductNav(e.target.querySelector('[data-kb-product-nav]'));
  });

  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.kb-fc-modal.is-active').forEach(function (modal) {
      closeModal(modal);
    });
    destroySwiper(e.target.querySelector('.kb-fc-swiper'));
    destroySwiper(e.target.querySelector('.kb-mc-swiper'));
    destroyProductNav(e.target);
  });
})();
